import {useState} from 'react';

import {FileImageVariant, useEditProfileQuery} from '#apollo/schema';
import {Text} from '#component/base';
import RectangleSkeleton from '#component/base/skeletons/RectangleSkeleton';
import {FullscreenLoading} from '#component/partial';
import {sprinkles} from '#style/sprinkles';
import {formatAPIDateForInput} from '#util';

import {AvatarImageInputAccount} from './AvatarImageInputAccount';
import FormAccountEdit from './FormAccountEdit';

import {
  accountTabWrapper,
  personalInfoHeadingText,
  personalInfoWrapper,
  profilePhotoHeadingText,
  profilePhotoWrapper,
} from './AccountTab.css';

const AccountTab = () => {
  const {data, loading} = useEditProfileQuery({
    variables: {imageVariant: FileImageVariant.Size_160x160},
  });
  const {me} = data ?? {};
  const {userProfile, avatar} = me ?? {};
  const {initials, birthday, email, formattedPhoneNumber} = userProfile ?? {};
  const [isUploadingAvatar, setIsUploadingAvatar] = useState(false);
  const formData = {
    ...userProfile,
    email: email ?? '',
    phoneNumber: formattedPhoneNumber ?? '',
    birthday: birthday ? formatAPIDateForInput(birthday) : '',
  };
  if (isUploadingAvatar) {
    return <FullscreenLoading />;
  }

  return !loading ? (
    <div className={accountTabWrapper}>
      <div className={personalInfoWrapper}>
        <Text as="h1" variant="heading3" color="burgundy" className={personalInfoHeadingText}>
          Personal Information{' '}
        </Text>
      </div>
      <div className={profilePhotoWrapper}>
        <Text as="h1" variant="label" color="dustyGray" className={profilePhotoHeadingText}>
          Profile Photo{' '}
        </Text>
      </div>
      <AvatarImageInputAccount
        image={avatar?.url}
        text={initials || '??'}
        loading={isUploadingAvatar}
        setLoading={setIsUploadingAvatar}
      />
      <FormAccountEdit formData={formData} />
    </div>
  ) : (
    <div className={sprinkles({flex: 'flex', marginTop: 40, width: 'full'})}>
      <RectangleSkeleton height={1300} width={1200} />
    </div>
  );
};

export default AccountTab;
